import React from "react";
import { Image, Tooltip } from "antd";
import ClockLogo from "../../../../icons/svg/fill-clock.svg";
import { DATE_TIME_FORMATS } from "../../../../utils/dateTimes";
import { convertUtcToLocal } from "../../../../library/utils";

const ClockStopNote = ({
  content = "",
  dateSent = null,
  alignment = "",
  messageContentClass = "",
}) => {
  const alignmentClasses = {
    left: "items-start",
    center: "items-center",
    right: "items-end",
  };

  const formattedDate = dateSent
    ? `on ${convertUtcToLocal(dateSent, DATE_TIME_FORMATS.MMM_D_YYYY_hh_mm_A)}`
    : "";

  return (
    <div className={`p-4 w-full text-black-88 flex flex-col ${alignmentClasses[alignment] || ""}`}>
      <Tooltip title={formattedDate}>
        <div>
          <Image className="!mt-[-2px]" src={ClockLogo} preview={false} />
          <span className="text-black-88 font-semibold text-xs ml-1">Clock stopped</span>
        </div>
      </Tooltip>
      <p className={`text-center text-xs text-black-65 font-normal mt-1 ${messageContentClass}`}>
        {content}
      </p>
    </div>
  );
};

export default ClockStopNote;
